import React from 'react';
import { useSelector } from 'react-redux';
import * as S from './PopularBusOperator.styles';
import { homeFaqDataSelector } from './../../../../containers/Home/redux/selectors';
import { pushCtaOmniEvents } from '../../../../utils/PushEvents/Omniture/clickEvents'
import { CTA_TYPE } from '../../../../utils/PushEvents/Omniture/utils' 

const ctaEventCaller = () => {
  pushCtaOmniEvents('Popular Bus Operators', CTA_TYPE.HYPER_LINK, 'Dweb_home', 'SRP Page');
}

const PopularBusOperator = () => {
  const { faqData } = useSelector(homeFaqDataSelector);

  if (faqData && faqData.data && faqData.data.template && faqData.data.template.interlinks) {
    const bus_operator_interlinks = (faqData.data.template.interlinks[0].bus_operator_interlinks);
    
    return (
      <S.PopularBusOperator >
        <p key={Math.random()} dangerouslySetInnerHTML={{
          __html: bus_operator_interlinks.title
        }}></p>
        <div onClick={ctaEventCaller}>
        <S.ContentBlock
          dangerouslySetInnerHTML={{
            __html: bus_operator_interlinks.links['bus operators']
          }}>
        </S.ContentBlock>
        </div>
      </S.PopularBusOperator>
    );
  } else {
    return <></>;
  }
};

export default PopularBusOperator;
